import { h } from '@stencil/core';

export const dataWithChevron = (data: string) => {
	const chevron = setChevronDirection(data);
	const icon = chevron ? <i class={`${chevron}`} aria-hidden="true"></i> : null;

	return (
		<div class="ds-fund-data">
			{icon} {data}
		</div>
	);
};

export const setChevronDirection = (value: string | number | null) => {
	let numberValue = null;

	if (typeof value === 'number') numberValue = value;
	else if (typeof value === 'string' && value.endsWith('%'))
		numberValue = value.slice(0, -1);
	else if (typeof value === 'string') numberValue = value;

	// Different locales have different decimal symbols, parseFloat works only with ".", not with ","
	if (isNaN(numberValue))
		numberValue = parseFloat(numberValue.replace(',', '.'));

	if (!isNaN(numberValue)) {
		if (numberValue === 0) return null;
		else if (numberValue > 0) return 'fa fa-chevron-up';
		else if (numberValue < 0) return 'fa fa-chevron-down';
	} else return null;
};
